(() => {
  document.querySelectorAll('[data-announcement-slider]').forEach((bar) => {
    const slides = [...bar.querySelectorAll('[data-announcement-slide]')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let timer;
    const advance = () => {
      const previous = slides[active];
      previous.classList.remove('is-active');
      previous.classList.add('is-leaving');
      previous.setAttribute('aria-hidden', 'true');
      previous.querySelector('a')?.setAttribute('tabindex', '-1');
      window.setTimeout(() => previous.classList.remove('is-leaving'), 500);
      active = (active + 1) % slides.length;
      slides[active].classList.add('is-active');
      slides[active].setAttribute('aria-hidden', 'false');
      slides[active].querySelector('a')?.removeAttribute('tabindex');
    };
    const resume = () => {
      window.clearInterval(timer);
      if (slides.length > 1 && !reduced.matches && !document.hidden && !bar.contains(document.activeElement)) timer = window.setInterval(advance, 3200);
    };
    bar.addEventListener('focusin', resume);
    bar.addEventListener('focusout', () => window.setTimeout(resume, 0));
    document.addEventListener('visibilitychange', resume);
    reduced.addEventListener('change', resume);
    resume();
  });

  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const opener = menu.querySelector(':scope > summary');
    const panel = menu.querySelector('.sinora-header__drawer-panel');
    const backdrop = menu.querySelector('[data-mobile-menu-close]');
    if (!opener || !panel) return;
    const focusableItems = () => [opener, ...panel.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), summary, shopify-account')]
      .filter((item) => item.getClientRects().length && item.getAttribute('aria-hidden') !== 'true');
    const close = (restoreFocus = true) => {
      menu.open = false;
      document.documentElement.classList.remove('sinora-menu-open');
      opener.setAttribute('aria-label', 'Open navigation menu');
      if (restoreFocus) requestAnimationFrame(() => opener.focus());
    };
    menu.addEventListener('toggle', () => {
      const isOpen = menu.open;
      document.documentElement.classList.toggle('sinora-menu-open', isOpen);
      opener.setAttribute('aria-label', isOpen ? 'Close navigation menu' : 'Open navigation menu');
      if (isOpen) requestAnimationFrame(() => panel.querySelector('nav a[href], nav summary')?.focus());
    });
    backdrop?.addEventListener('click', () => close());
    panel.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) close(false);
    });
    menu.addEventListener('keydown', (event) => {
      if (!menu.open) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const items = focusableItems();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
    window.matchMedia('(min-width: 1025px)').addEventListener('change', (event) => { if (event.matches && menu.open) close(false); });
  });

  const desktopMenu = window.matchMedia('(min-width: 1025px) and (hover: hover)');
  document.querySelectorAll('.sinora-header__nav-item').forEach((item) => {
    const summary = item.querySelector(':scope > summary');
    let closeTimer;
    if (!summary) return;
    const open = () => {
      if (!desktopMenu.matches) return;
      window.clearTimeout(closeTimer);
      item.open = true;
    };
    const close = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (desktopMenu.matches && !item.matches(':hover') && !item.contains(document.activeElement)) item.open = false;
      }, 180);
    };
    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', close);
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !item.open) return;
      event.preventDefault();
      item.open = false;
      summary.focus();
    });
  });

  document.querySelectorAll('[data-lookbook-grid]').forEach((grid) => {
    const cards = [...grid.querySelectorAll('[data-lookbook-card]')];
    const buttons = [...grid.parentElement.querySelectorAll('[data-lookbook-page]')];
    if (!buttons.length) return;
    const show = (page) => {
      page = Math.max(0, Math.min(buttons.length - 1, page));
      cards.forEach((card, index) => { card.hidden = Math.floor(index / 8) !== page; });
      buttons.forEach((button, index) => { if (index === page) button.setAttribute('aria-current', 'page'); else button.removeAttribute('aria-current'); });
    };
    const fromUrl = () => show((Number(new URL(window.location.href).searchParams.get('lookbook_page')) || 1) - 1);
    buttons.forEach((button) => button.addEventListener('click', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('lookbook_page', Number(button.dataset.lookbookPage) + 1);
      history.pushState(null, '', url);
      show(Number(button.dataset.lookbookPage));
      grid.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }));
    window.addEventListener('popstate', fromUrl);
    fromUrl();
  });
  const hero = document.querySelector('[data-sinora-hero]');
  if (hero) {
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const counter = hero.querySelector('[data-hero-count]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        slide.classList.toggle('is-active', position === active);
        slide.setAttribute('aria-hidden', String(position !== active));
        slide.querySelectorAll('a, button').forEach((item) => { item.tabIndex = position === active ? 0 : -1; });
      });
      if (counter) counter.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    const pause = () => window.clearInterval(timer);
    const resume = () => {
      pause();
      if (slides.length > 1 && !reduced.matches && !document.hidden) timer = window.setInterval(() => show(active + 1), Number(hero.dataset.delay) || 6000);
    };
    hero.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(active - 1); resume(); });
    hero.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(active + 1); resume(); });
    hero.addEventListener('focusin', pause);
    hero.addEventListener('focusout', resume);
    document.addEventListener('visibilitychange', resume);
    reduced.addEventListener('change', resume);
    show(0);
    resume();
  }

  const initializeFeatured = (section) => {
    section._sinoraFeaturedCleanup?.();
    const rail = section.querySelector('[data-featured-rail]');
    const previous = section.querySelector('[data-featured-prev]');
    const next = section.querySelector('[data-featured-next]');
    if (!rail) {
      previous?.setAttribute('hidden', '');
      next?.setAttribute('hidden', '');
      section._sinoraFeaturedCleanup = () => {};
      return;
    }
    previous?.removeAttribute('hidden');
    next?.removeAttribute('hidden');
    const controller = new AbortController();
    const listener = { signal: controller.signal };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer;
    let scrollTimer;
    let resizeFrame;
    let visible = true;
    let observer;
    let looping = false;
    let originalStart = 0;
    let setSpan = 0;
    let stepSize = 0;
    let activeIndex = 0;
    const originals = [...rail.querySelectorAll(':scope > .sinora-product-card:not([data-featured-clone])')];
    const modulo = (value, divisor) => ((value % divisor) + divisor) % divisor;
    const position = (card) => card.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
    const clones = () => [...rail.querySelectorAll(':scope > [data-featured-clone]')];
    const removeClones = () => clones().forEach((clone) => clone.remove());
    const cloneCard = (card) => {
      const clone = card.cloneNode(true);
      clone.dataset.featuredClone = '';
      clone.setAttribute('aria-hidden', 'true');
      [clone, ...clone.querySelectorAll('[id]')].forEach((element) => element.removeAttribute('id'));
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => { element.tabIndex = -1; });
      return clone;
    };
    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };
    const start = () => {
      stop();
      if (looping && !reduced.matches && !document.hidden && visible && !section.contains(document.activeElement)) timer = window.setInterval(() => move(1), Number(section.dataset.slideInterval) || 3000);
    };
    const rebase = () => {
      if (!looping || !setSpan) return;
      let destination = rail.scrollLeft;
      while (destination < originalStart - 2) destination += setSpan;
      while (destination >= originalStart + setSpan - 2) destination -= setSpan;
      if (Math.abs(destination - rail.scrollLeft) > 1) rail.scrollTo({ left: destination, behavior: 'auto' });
      activeIndex = modulo(Math.round((destination - originalStart) / stepSize), originals.length);
    };
    const settle = () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = undefined;
      rebase();
      start();
    };
    const move = (direction) => {
      if (!looping) return;
      stop();
      rail.scrollTo({ left: rail.scrollLeft + direction * stepSize, behavior: reduced.matches ? 'auto' : 'smooth' });
      if (reduced.matches) window.requestAnimationFrame(settle);
    };
    const rebuild = () => {
      stop();
      removeClones();
      rail.scrollTo({ left: 0, behavior: 'auto' });
      const naturalOverflow = rail.scrollWidth > rail.clientWidth + 2;
      looping = originals.length > 1 && naturalOverflow;
      if (previous) previous.disabled = !looping;
      if (next) next.disabled = !looping;
      if (!looping) return;
      const prepended = originals.map(cloneCard);
      const appended = originals.map(cloneCard);
      rail.prepend(...prepended);
      rail.append(...appended);
      stepSize = originals[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
      originalStart = position(originals[0]);
      setSpan = position(appended[0]) - originalStart;
      rail.scrollTo({ left: originalStart + modulo(activeIndex, originals.length) * stepSize, behavior: 'auto' });
      start();
    };
    previous?.addEventListener('click', () => move(-1), listener);
    next?.addEventListener('click', () => move(1), listener);
    section.addEventListener('focusin', stop, listener);
    section.addEventListener('focusout', () => window.requestAnimationFrame(start), listener);
    document.addEventListener('visibilitychange', start, listener);
    reduced.addEventListener('change', start, listener);
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(rebuild);
    }, listener);
    if ('onscrollend' in rail) rail.addEventListener('scrollend', settle, listener);
    else rail.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(settle, 140);
    }, listener);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; start(); }, { threshold: 0.05 });
      observer.observe(section);
    }
    section._sinoraFeaturedCleanup = () => {
      stop();
      window.clearTimeout(scrollTimer);
      window.cancelAnimationFrame(resizeFrame);
      observer?.disconnect();
      controller.abort();
      removeClones();
      delete section._sinoraFeaturedCleanup;
    };
    rebuild();
  };

  document.querySelectorAll('[data-sinora-featured]').forEach(initializeFeatured);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('[data-sinora-featured]')) initializeFeatured(event.target);
    event.target.querySelectorAll?.('[data-sinora-featured]').forEach(initializeFeatured);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.('[data-sinora-featured]') ? event.target : event.target.querySelector?.('[data-sinora-featured]');
    section?._sinoraFeaturedCleanup?.();
  });

  document.querySelectorAll('[data-product-tabs]').forEach((section) => {
    const tabs = [...section.querySelectorAll('[data-product-tab]')];
    const panels = [...section.querySelectorAll('[data-product-panel]')];
    if (!tabs.length || tabs.length !== panels.length) return;
    section.classList.add('js-enabled');
    section.querySelector('[data-product-tab-list]')?.setAttribute('role', 'tablist');
    tabs.forEach((tab) => tab.setAttribute('role', 'tab'));
    panels.forEach((panel) => { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
    const select = (index, focus = false) => {
      tabs.forEach((tab, position) => {
        tab.setAttribute('aria-selected', String(position === index));
        tab.tabIndex = position === index ? 0 : -1;
        panels[position].hidden = position !== index;
      });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
    select(0);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((rail) => {
    const gallery = rail.closest('.sinora-product__gallery');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const items = [...rail.querySelectorAll('.sinora-product__media-item')];
    const thumbnails = [...(gallery?.querySelectorAll('[data-gallery-thumbnail]') || [])];
    if (!items.length) return;
    const imagesOnly = items.every((item) => item.dataset.mediaType === 'image');
    if (!imagesOnly) rail.dataset.galleryMixed = '';
    items.forEach((item, index) => { item.dataset.galleryIndex = index; });
    let timer;
    let settleTimer;
    let visible = true;
    let manuallyStopped = false;
    let dragging = false;
    let moving = false;
    let rebasing = false;
    let looping = false;
    let active = 0;
    let physicalItems = items;
    let lastWidth = 0;
    const modulo = (index) => (index + items.length) % items.length;
    const overflow = () => rail.scrollWidth > rail.clientWidth + 2;
    const position = (item) => item.offsetLeft - physicalItems[0].offsetLeft;
    const nearest = () => physicalItems.reduce((best, item, index) => Math.abs(position(item) - rail.scrollLeft) < Math.abs(position(physicalItems[best]) - rail.scrollLeft) ? index : best, 0);
    const indicate = () => {
      active = Number(physicalItems[nearest()].dataset.galleryIndex);
      thumbnails.forEach((button, index) => { if (index === active) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
    };
    // Move between identical image positions without animating backwards.
    const rebase = (left) => {
      rebasing = true;
      rail.classList.add('is-rebasing');
      rail.scrollTo({ left, behavior: 'instant' });
      requestAnimationFrame(() => requestAnimationFrame(() => {
        rail.classList.remove('is-rebasing');
        rebasing = false;
        indicate();
      }));
    };
    const settle = () => {
      window.clearTimeout(settleTimer);
      if (dragging || rebasing) return;
      moving = false;
      indicate();
      const item = physicalItems[nearest()];
      if (looping && item.hasAttribute('data-gallery-clone')) {
        rebase(rail.scrollLeft + position(items[active]) - position(item));
      }
    };
    const moveTo = (item, instant = false) => {
      if (!item) return;
      window.clearTimeout(settleTimer);
      moving = true;
      rail.scrollTo({ left: position(item), behavior: instant || reduced.matches ? 'instant' : 'smooth' });
      settleTimer = window.setTimeout(settle, 180);
    };
    const move = (direction, manual = false) => {
      if (!overflow() || dragging || rebasing || (moving && !manual)) return;
      indicate();
      const index = modulo(active + direction);
      if (looping) moveTo(physicalItems[nearest() + direction] || items[index]);
      else moveTo(items[index], (direction > 0 && index === 0) || (direction < 0 && index === items.length - 1));
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (overflow() && !reduced.matches && !document.hidden && visible && !manuallyStopped && !dragging) {
        timer = window.setInterval(() => {
          const engaged = !imagesOnly && items.some((item) => [...item.querySelectorAll('video')].some((video) => !video.paused) || (item.dataset.mediaType !== 'image' && item.contains(document.activeElement)));
          if (!engaged) move(1);
        }, Number(rail.dataset.galleryInterval) || 3000);
      }
    };
    const clone = (item) => {
      const copy = item.cloneNode(true);
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      copy.setAttribute('data-gallery-clone', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      return copy;
    };
    const layout = () => {
      if (!rail.clientWidth) return;
      const saved = active;
      const slots = Math.max(1, Math.round(rail.clientWidth / items[0].getBoundingClientRect().width));
      const shouldLoop = imagesOnly && items.length > slots;
      if (shouldLoop !== looping) {
        rail.querySelectorAll('[data-gallery-clone]').forEach((item) => item.remove());
        looping = shouldLoop;
        if (looping) {
          // Two neighbours on either side cover the desktop pair and mobile swipe.
          rail.prepend(...items.slice(-2).map(clone));
          rail.append(...items.slice(0, 2).map(clone));
          rail.dataset.galleryLooping = '';
        } else delete rail.dataset.galleryLooping;
        physicalItems = [...rail.querySelectorAll('.sinora-product__media-item')];
      }
      moving = false;
      window.clearTimeout(settleTimer);
      rebase(position(items[saved]));
      start();
    };
    gallery?.addEventListener('click', (event) => {
      const arrow = event.target.closest('[data-gallery-prev], [data-gallery-next]');
      if (arrow) { manuallyStopped = true; stop(); move(arrow.hasAttribute('data-gallery-next') ? 1 : -1, true); return; }
      const thumbnail = event.target.closest('[data-gallery-thumbnail]');
      if (thumbnail) { moveTo(items[Number(thumbnail.dataset.galleryThumbnail)]); start(); }
    });
    rail.addEventListener('sinora:gallery-select', (event) => {
      moveTo(items.find((item) => item.id === `product-media-${event.detail.mediaId}`));
      start();
    });
    rail.addEventListener('scroll', () => {
      if (rebasing) return;
      moving = true;
      indicate();
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle, 150);
    }, { passive: true });
    rail.addEventListener('scrollend', settle);
    rail.addEventListener('pointerdown', () => { dragging = true; stop(); }, { passive: true });
    const release = () => { if (dragging) { dragging = false; settleTimer = window.setTimeout(settle, 150); start(); } };
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    document.addEventListener('visibilitychange', start);
    reduced.addEventListener('change', start);
    if ('ResizeObserver' in window) new ResizeObserver(() => {
      if (rail.clientWidth !== lastWidth) { lastWidth = rail.clientWidth; layout(); }
    }).observe(rail);
    else window.addEventListener('resize', layout);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; start(); }, { threshold: 0.05 });
      observer.observe(gallery || rail);
    }
    layout();
  });

  document.querySelectorAll('select[data-auto-submit]').forEach((input) => {
    input.addEventListener('change', () => input.form?.requestSubmit());
  });

  const cartRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const cartDrawer = () => document.querySelector('[data-cart-drawer]');
  let cartBusy = false;
  let cartFocusReturn;
  const cartError = (message) => {
    const error = cartDrawer()?.querySelector('[data-cart-drawer-error]');
    if (error) { error.textContent = message; error.hidden = false; }
  };
  const updateCartCount = async () => {
    const response = await fetch(`${cartRoot}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not refresh your bag.');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => { trigger.setAttribute('aria-label', `Bag with ${cart.item_count} items`); });
  };
  const drawerFromHtml = (html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
  const refreshCartDrawer = async (sectionHtml) => {
    let fresh = sectionHtml ? drawerFromHtml(sectionHtml) : null;
    if (!fresh) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', 'sinora-cart-drawer');
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Could not refresh your bag.');
      fresh = drawerFromHtml(await response.text());
    }
    if (!fresh) throw new Error('Could not display your bag.');
    const previous = cartDrawer();
    const wasOpen = previous?.open;
    if (wasOpen) previous.close();
    previous?.replaceWith(document.importNode(fresh, true));
    if (wasOpen) cartDrawer()?.showModal();
  };
  const showCartDrawer = () => {
    const drawer = cartDrawer();
    if (!drawer || drawer.open) return;
    drawer.showModal();
    drawer.querySelector('[data-cart-close]')?.focus();
  };
  const addToCart = async (formData, openDrawer = true) => {
    if (cartBusy) return false;
    cartBusy = true;
    formData.set('sections', 'sinora-cart-drawer');
    formData.set('sections_url', window.location.pathname + window.location.search);
    try {
      const response = await fetch(`${cartRoot}cart/add.js`, { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This item could not be added.');
      if (openDrawer) {
        showCartDrawer();
        try { await refreshCartDrawer(result.sections?.['sinora-cart-drawer']); }
        catch (_) { cartError('Added to bag. Use View Bag to see your updated selection.'); }
        updateCartCount().catch(() => {});
      }
      return true;
    } finally { cartBusy = false; }
  };
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-cart-trigger]');
    if (trigger) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      cartFocusReturn = trigger;
      showCartDrawer();
      try { await refreshCartDrawer(); updateCartCount().catch(() => {}); }
      catch (_) { cartError('Could not refresh the bag. Use View Bag for the current selection.'); }
      return;
    }
    if (event.target.matches('[data-cart-drawer]')) { event.target.close(); cartFocusReturn?.focus(); return; }
    if (event.target.closest('[data-cart-close]')) { cartDrawer()?.close(); cartFocusReturn?.focus(); return; }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      if (cartBusy) return;
      cartBusy = true;
      try {
        const response = await fetch(`${cartRoot}cart/change.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: change.dataset.cartLine, quantity: Number(change.dataset.cartQuantity), sections: 'sinora-cart-drawer', sections_url: window.location.pathname + window.location.search })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Could not update your bag.');
        await refreshCartDrawer(result.sections?.['sinora-cart-drawer']);
        await updateCartCount();
      } catch (error) { cartError(error.message); }
      finally { cartBusy = false; }
      return;
    }
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = step.closest('form')?.querySelector('input[name="quantity"]');
      if (input) { input.value = Math.max(1, (Number(input.value) || 1) + Number(step.dataset.quantityStep)); input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    const buyNow = event.target.closest('[data-buy-now]');
    if (buyNow) {
      const form = buyNow.closest('form');
      if (!form?.reportValidity()) return;
      buyNow.disabled = true;
      try { if (await addToCart(new FormData(form), false)) window.location.assign(`${cartRoot}checkout`); }
      catch (error) { const panel = form.querySelector('[data-cart-error]'); if (panel) { panel.textContent = error.message; panel.hidden = false; } }
      finally { buyNow.disabled = false; }
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.sinora-product__form');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const button = form.querySelector('[data-product-submit]');
    const panel = form.querySelector('[data-cart-error]');
    if (panel) panel.hidden = true;
    if (button) { button.disabled = true; button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding to bag'; }
    try { await addToCart(new FormData(form)); }
    catch (error) { if (panel) { panel.textContent = error.message; panel.hidden = false; } }
    finally { if (button) { button.disabled = false; button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); button.textContent = 'Add to cart'; } }
  });

  document.querySelectorAll('[data-sinora-predictive]').forEach((form) => {
    const input = form.querySelector('input[type=search]');
    const results = form.querySelector('#sinora-predictive-results');
    let timer;
    let request;
    input?.addEventListener('input', () => {
      window.clearTimeout(timer);
      request?.abort();
      const query = input.value.trim();
      if (query.length < 2) { results.replaceChildren(); input.setAttribute('aria-expanded', 'false'); return; }
      timer = window.setTimeout(async () => {
        request = new AbortController();
        const url = new URL(form.dataset.predictiveUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('section_id', 'sinora-predictive-search');
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const panel = doc.querySelector('.sinora-predictive__panel');
          results.replaceChildren(...(panel ? [document.importNode(panel, true)] : []));
          input.setAttribute('aria-expanded', String(Boolean(panel)));
        } catch (error) { if (error.name !== 'AbortError') results.replaceChildren(); }
      }, 220);
    });
    input?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { results.replaceChildren(); input.setAttribute('aria-expanded', 'false'); }
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const root = select.closest('[data-product-root]');
    root?.classList.add('js-enabled');
    const price = root?.querySelector('[data-product-price]');
    const comparePrice = root?.querySelector('[data-product-compare-price]');
    const unitPrice = root?.querySelector('[data-product-unit-price]');
    const availability = root?.querySelector('[data-product-availability]');
    const button = root?.querySelector('[data-product-submit]');
    const buyNow = root?.querySelector('[data-buy-now]');
    const pickup = root?.querySelector('[data-sinora-pickup]');
    const optionGroups = [...(root?.querySelectorAll('[data-product-option]') || [])];
    let pickupRequest;
    const loadPickup = async (variantId) => {
      if (!pickup) return;
      pickupRequest?.abort();
      pickupRequest = new AbortController();
      const route = `${pickup.dataset.rootUrl.replace(/\/?$/, '/') }variants/${variantId}/?section_id=sinora-pickup-availability`;
      try {
        const response = await fetch(route, { signal: pickupRequest.signal });
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = parsed.querySelector('[data-sinora-pickup-content]');
        pickup.replaceChildren(...(content ? [document.importNode(content, true)] : []));
      } catch (_) { /* Pickup is unavailable when the merchant has no pickup locations. */ }
    };
    const update = (scrollMedia = false) => {
      const option = select.selectedOptions[0];
      if (!option) return;
      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) { comparePrice.textContent = option.dataset.comparePrice || ''; comparePrice.hidden = !option.dataset.comparePrice; }
      if (unitPrice) { unitPrice.textContent = option.dataset.unitPrice || ''; unitPrice.hidden = !option.dataset.unitPrice; }
      const available = option.dataset.available === 'true';
      if (availability) availability.textContent = available ? 'Available' : 'Sold out';
      if (button) { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out'; }
      if (buyNow) buyNow.disabled = !available;
      const mediaId = option.dataset.mediaId;
      if (mediaId && scrollMedia) root?.querySelector('[data-product-gallery]')?.dispatchEvent(new CustomEvent('sinora:gallery-select', { detail: { mediaId } }));
      optionGroups.forEach((group) => {
        const selectedValue = option.dataset[`option${group.dataset.productOption}`] || '';
        group.querySelectorAll('[data-option-value]').forEach((choice) => choice.setAttribute('aria-pressed', String(choice.dataset.optionValue === selectedValue)));
        const current = group.querySelector('[data-option-current]');
        if (current) current.textContent = selectedValue;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      if (pickup && pickup.dataset.variantId !== option.value) {
        pickup.dataset.variantId = option.value;
        loadPickup(option.value);
      }
    };
    select.addEventListener('change', () => update(true));
    const chooseVariant = () => {
      const variant = [...select.options].find((candidate) => optionGroups.every((group) => candidate.dataset[`option${group.dataset.productOption}`] === group.querySelector('[data-option-value][aria-pressed="true"]')?.dataset.optionValue));
      if (!variant) {
        select.value = '';
        if (availability) availability.textContent = 'Unavailable combination';
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        if (buyNow) buyNow.disabled = true;
        return;
      }
      select.value = variant.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    optionGroups.forEach((group) => group.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-option-value]');
      if (!choice) return;
      group.querySelectorAll('[data-option-value]').forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
      chooseVariant();
    }));
    update();
    loadPickup(select.value);
  });

  document.querySelectorAll('[data-sinora-recommendations]').forEach((section) => {
    const load = async () => {
      try {
        const response = await fetch(section.dataset.url);
        if (!response.ok) return;
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = documentFragment.querySelector('[data-sinora-recommendations]');
        if (content?.querySelector('.sinora-product-card')) { section.replaceChildren(...content.childNodes); section.classList.add('is-loaded'); }
      } catch (_) { /* Recommendations are optional when Shopify returns none. */ }
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        load();
      }, { rootMargin: '200px' });
      observer.observe(section);
    } else load();
  });
})();
